import { Grid, Typography } from "@mui/material";
import Appointment from "../interface/appointment";
import getAppointmentStatusText from "../functions/getAppointmentStatusText";

const RenderAppointmentStatus = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    md={1}
    sx={{
      display: appointment.isSpeedcoaching ? "none" : "flex",
      alignItems: "center",
    }}
  >
    <Typography
      variant="body1"
      color="initial"
      sx={{
        wordBreak: "break-all",
        overflowWrap: "break-word",
        whiteSpace: "normal",
      }}
    >
      {getAppointmentStatusText(appointment)}
    </Typography>
  </Grid>
);

export default RenderAppointmentStatus;
